import { ArrangementType } from 'estensa-module';
import { IChannelSelector, ILayout } from '../models/interfaces';
import { IChannel } from '../models/ichannel';

export class ChannelSelector implements IChannelSelector {
    // data members

    channels: IChannel[];
    selectedChannel: IChannel;
    onSelectChannel: (channel: IChannel) => void;
    private _layout: ILayout;

    constructor(originalChannel: IChannel | null, derivedChannel: IChannel | null, layout: ILayout) {
        this._originalChannel = originalChannel;
        this._derivedChannel = derivedChannel;
        this._layout = layout;
    }

    get currentChannel() {
        return this._layout.ecgState.chartState.arrangement == ArrangementType.Medians
            ? this._derivedChannel
            : this._originalChannel;
    }

    // constructor

    private _originalChannel: IChannel | null;

    get originalChannel() {
        return this._originalChannel;
    }

    private _derivedChannel: IChannel | null;

    get derivedChannel() {
        return this._derivedChannel;
    }
}
